/**
 * MotoMillion Sidebar Filter Search
 * Extracted from inline Liquid to reduce server-side render time.
 *
 * Binds to [data-mm-filter-search-input] elements and filters
 * flat lists (brand) or category tree accordions (category/product).
 */
(function () {
  if (window.mmSidebarFilterSearchInit) return;
  window.mmSidebarFilterSearchInit = true;

  function normalizeText(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .trim();
  }

  function getLabelTextFromItem(item) {
    var textEl = item.querySelector('.faceted-filter-group-display__list-item-label-text');
    return normalizeText(textEl ? textEl.textContent : item.textContent);
  }

  function filterFlatList(groupDisplay, term) {
    var items = Array.from(
      groupDisplay.querySelectorAll(':scope .faceted-filter-group-display__list > .faceted-filter-group-display__list-item')
    );

    var visibleCount = 0;

    items.forEach(function (item) {
      var isMatch = !term || getLabelTextFromItem(item).includes(term);
      item.style.display = isMatch ? '' : 'none';
      if (isMatch) visibleCount += 1;
    });

    return visibleCount;
  }

  function filterCategoryAccordion(node, term) {
    if (!node) return false;

    if (node.classList.contains('mm-moto-item')) {
      var isMatch = !term || getLabelTextFromItem(node).includes(term);
      node.style.display = isMatch ? '' : 'none';
      return isMatch;
    }

    if (node.classList.contains('mm-moto-accordion')) {
      var summary = node.querySelector(':scope > summary');
      var body = node.querySelector(':scope > .mm-moto-accordion__body');
      var ownText = normalizeText(summary ? summary.textContent : '');
      var childNodes = body
        ? Array.from(body.children).filter(function (child) {
            return child.classList.contains('mm-moto-accordion') || child.classList.contains('mm-moto-item');
          })
        : [];

      var childMatchCount = 0;
      childNodes.forEach(function (child) {
        if (filterCategoryAccordion(child, term)) childMatchCount += 1;
      });

      var selfMatches = !!term && ownText.includes(term);
      var visible = !term || selfMatches || childMatchCount > 0;

      node.style.display = visible ? '' : 'none';

      if (term && visible && childMatchCount > 0) {
        node.open = true;
      }

      return visible;
    }

    return false;
  }

  function filterCategoryTree(groupDisplay, term) {
    var treeMount = groupDisplay.querySelector('[data-mm-moto-tree-mount]');
    if (!treeMount) return 0;

    var topNodes = Array.from(treeMount.children).filter(function (child) {
      return child.classList.contains('mm-moto-accordion') || child.classList.contains('mm-moto-item');
    });

    var visibleCount = 0;
    topNodes.forEach(function (node) {
      if (filterCategoryAccordion(node, term)) visibleCount += 1;
    });

    return visibleCount;
  }

  function ensureEmptyMessage(groupDisplay) {
    var emptyEl = groupDisplay.querySelector('.mm-filter-search-empty');
    if (!emptyEl) {
      emptyEl = document.createElement('div');
      emptyEl.className = 'mm-filter-search-empty';
      emptyEl.textContent = 'No matches found';
      groupDisplay.appendChild(emptyEl);
    }
    return emptyEl;
  }

  function bindFilterSearch(input) {
    if (!input || input.dataset.mmFilterSearchBound === 'true') return;
    input.dataset.mmFilterSearchBound = 'true';

    var groupDisplay = input.closest('.faceted-filter-group-display');
    if (!groupDisplay) return;

    var filterType = input.dataset.mmFilterType || '';
    var emptyEl = ensureEmptyMessage(groupDisplay);

    var run = function () {
      var term = normalizeText(input.value);
      var visibleCount = 0;

      if (filterType === 'brand') {
        visibleCount = filterFlatList(groupDisplay, term);
      } else if (filterType === 'category' || filterType === 'product') {
        visibleCount = filterCategoryTree(groupDisplay, term);
      }

      emptyEl.classList.toggle('is-visible', !!term && visibleCount === 0);

      var root = groupDisplay.querySelector('[data-mm-moto-tree-root]');
      if (root) {
        root.dispatchEvent(new CustomEvent('mm:filter:resize', { bubbles: true }));
      }
    };

    input.addEventListener('input', run);
    input.addEventListener('search', run);
  }

  function initAllFilterSearches(scope) {
    (scope || document).querySelectorAll('[data-mm-filter-search-input]').forEach(bindFilterSearch);
  }

  window.mmSidebarFilterSearchInitAll = initAllFilterSearches;

  document.addEventListener('DOMContentLoaded', function () {
    initAllFilterSearches(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllFilterSearches(event.target || document);
  });

  initAllFilterSearches(document);
})();
